import React from 'react';
import Chart from '../components/Chart/Chart';

const ChartPage: React.FC = () => (
  <div className="page__wrapper chart">
    <Chart />
  </div>
);
export default React.memo(ChartPage);
